import React from "react";
import Herohacking from "../../components/updatehackinginternship/Herohacking";

import HackingTools from "../../components/updatehackinginternship/HackingTools";
import HackingAdmissionProcess from "../../components/updatehackinginternship/HackingAdmissionProcess";

import SyllabusPiechat from "../../components/updatehackinginternship/SyllabusPiechat";
import CybersecurityProjects from "../../components/updatehackinginternship/CybersecurityProjects";
import HackingTechniques from "../../components/updatehackinginternship/HackingTechniques";
import HackingCoursecurriculum from "../../components/updatehackinginternship/HackingCoursecurriculum";
import HackingBenefits from "../../components/updatehackinginternship/HackingBenefits";
import PlacementCompanies from "../home/PlacementCompanies";
import AboutHackingMentor from "../../components/updatehackinginternship/AboutHackingMentor";
import HackingAdmissionProcess2 from "../../components/updatehackinginternship/HackingAdmissionProcess2";
import HackingPlacements from "../../components/updatehackinginternship/HackingPlacements";
import HackingReview from "../../components/updatehackinginternship/HackingReview";
import HackingGallery from "../../components/updatehackinginternship/HackingGallery";

const HackingIntrenship = () => {
  return (
    <div>
      <Herohacking />

      <HackingTools />
      <HackingBenefits />
      <HackingTechniques />
      <HackingCoursecurriculum />
      <CybersecurityProjects />

      <div style={{ padding: "100px 0px" }}>
        <PlacementCompanies />
      </div>

      <HackingAdmissionProcess />
      <HackingAdmissionProcess2 />

      <SyllabusPiechat />

      <AboutHackingMentor />

      <HackingPlacements />
      <HackingReview />
      {/* <HackingGallery/> */}
    </div>
  );
};

export default HackingIntrenship;
